import React from 'react';
// Constants
import {
  AddressLine1,
  AddressLine2,
  AddressLine3,
  CompanyPhoneNumber,
} from '../../utils/Constants';

const GeneralFooter = ({ title }) => {
  return (
    <section className='grid w-full h-full'>
      {/* Contact Information */}
      <section className='grid md:grid-cols-3 text-center'>
        {/* Text Box */}
        <section className='bg-colour2 grid items-center text-colour1 px-6 py-10 lg:py-12'>
          <div className='grid h-fit'>
            <h4 className='text-xl lg:text-3xl grid items-center font-semibold'>
              {title}
            </h4>
          </div>
        </section>

        {/* Phone Box */}
        <section className='bg-colour6 grid items-center text-center px-6 py-10 lg:py-12'>
          <div className='grid h-fit'>
            <h2 className='text-xl lg:text-3xl font-semibold text-colour'>
              Call Now
            </h2>
            <p className='mt-2'>
              <a
                href={`tel:${CompanyPhoneNumber}`}
                className='text-colour2 hover:underline lg:text-xl'
              >
                {CompanyPhoneNumber}
              </a>
            </p>
          </div>
        </section>

        {/* Address Box */}
        <section className='bg-colour1 grid items-center px-6 py-10 lg:py-12'>
          <div className='grid h-fit'>
            <h2 className='text-xl lg:text-3xl font-semibold text-colour2'>
              Find Us
            </h2>
            <address className='not-italic leading-5 lg:text-xl'>
              <p>{AddressLine1}</p>
              <p>{AddressLine2}</p>
              <p>{AddressLine3}</p>
            </address>
          </div>
        </section>
      </section>
    </section>
  );
};

export default GeneralFooter;
